export default __webpack_public_path__ + "static/media/captaindev.b53501fc.webp";